export const DEFAULT_TARGETING_PAGINATION_LIMIT = 100;
